"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderType = exports.orderStatusColor = exports.orderStatus = void 0;
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/defineProperty.js"));
var orderType = exports.orderType = {
  ASSURANCE_WIRELESS: "ASSURANCE WIRELESS",
  SAFELINK_WIRELESS: "SAFELINK WIRELESS",
  MAXSIP_WIRELESS: "MAXSIP WIRELESS"
};
var orderStatus = exports.orderStatus = {
  New: "NEW",
  Denied: "DENIED",
  Approved: "APPROVED",
  Ordered: "ORDERED",
  Shipped: "SHIPPED"
};
var orderStatusColor = exports.orderStatusColor = (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, orderStatus.New, {
  type: "",
  effect: "plain"
}), orderStatus.Ordered, {
  type: "success",
  effect: "plain"
}), orderStatus.Denied, {
  type: "danger",
  effect: "dark"
}), orderStatus.Approved, {
  type: "success",
  effect: "dark"
}), orderStatus.Shipped, {
  type: "",
  effect: "dark"
});